import * as React from "react";
import { getDetailShortLink } from "../api/link";
import { useParams, useNavigate } from "react-router-dom";

const GoToLink = () => {
  const { shortId } = useParams();
  const navigate = useNavigate();
  const fetchData = async () => {
    try {
      const { data } = await getDetailShortLink(shortId);
      if (data.link !== undefined && data.link.includes("http")) {
        window.open(data.link, "_self");
      } else {
        navigate("/404");
      }
    } catch (error) {
      navigate("/404");
    }
  };
  React.useEffect(() => {
    if (!shortId) return;

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shortId, navigate]);

  return <>Loading...</>;
};

export default GoToLink;
